import { BsSearch, BsFilter } from "react-icons/bs";
import TemplateBackend from "../TemplateBackend";
import BootyPagination from "../../components/Pagination";
import Loading from "../../components/Loading";
import DataTable, { TableColumn } from "react-data-table-component";
import "./styles/style.css";
import { useContext, useEffect, useState } from "react";
import React from "react";
import { LoginContext } from "../../contexts/login_context";
import { customStyles } from "./styles/customStyles";
import ModalFilter from "./modal/modal";
import PreviewEmbedModal from "./PreviewEmbedModal";
import { toast } from "react-toastify";
import ModalEdit from "./modal/modalEdit";
import { getAllResearchs } from "../../services/TodasPesquisas";
import { createResearch } from "../../services/criarPesquisa";
import * as xlsx from "xlsx";
import { deleteResearch } from "../../services/deletePesquisa";
import Modal from 'react-modal';
import { IoMdClose } from "react-icons/io";

type FiltroPesquisa = {
  titulo: string;
  status: "Ativo" | "Inativo" | ""; 
  criadoDe: string;
  criadoAte: string;
};

export type Pesquisa = {
  _id: string;
  titulo: string;
  dataCriacao?: string;
  inicio?: string;
  termino?: string;
  inativo?: boolean;
  usuarioCriacao?: { nome?: string; email?: string; _id?: string };

  embedCode?: string;
  cadsSelecionados?: string[];
  observacao?: string;
  origem?: string;
};

export type Linha = {
  id: string;
  titulo: string;
  criadoPor: string;
  criadoEm: string;
  dataInicio: string;
  dataFim: string;
  status: string;
  pesquisaOriginal: Pesquisa;
};

const Research = () => {
  const [hideColumnCompany, setHideColumnCompany] = useState(false);
  const [hideColumnType, setHideColumnType] = useState(false);
  const [userLoading, setUserLoading] = useState(false);
  const { jwt, perfil } = useContext(LoginContext);
  const [stateModal, setStateModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showTable, setShowTable] = useState(true);
  const [showOptions, setShowOptions] = useState<"table" | "form" | "edit">(
    "table"
  );
  const [publico, setPublico] = useState("Enviar planilha");
  const [researchPeriod, setResearchPeriod] = useState<{ start: string; end: string }>({
    start: "",
    end: "",
  });
  const [embedCode, setEmbedCode] = useState("");
  const [selectProfile, setSelectProfile] = useState("Todos");
  const [textareaGTINs, setTextareaGTIns] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [titulo, setTitulo] = useState("");
  const [newResearch, setNewResearch] = useState("");
  const [openEmbedCode, setOpenEmbedCode] = useState(false);
  const [selectRow, setSelectRow] = useState<any>(null);
  const [status, setStatus] = useState(true);
  const [allResearchs, setAllResearchs] = useState<Pesquisa[]>([]);
  const [v, setV] = useState("");
  const [cadPreview, setCadPreview] = useState<string[]>([]);
  const [cadCount, setCadCount] = useState(0);

  const [filtros, setFiltros] = useState<FiltroPesquisa>({
    titulo: "",
    status: "",
    criadoDe: "",
    criadoAte: "",
  });

  const [showFilterModal, setShowFilterModal] = useState(false);
  const [ipsOpenModalDelete, setIpsOpenModalDelete] = useState(false);

  function calcularDias(inicio: string, fim: string) {
    if (!inicio || !fim) return 0;

    const startDate = new Date(inicio);
    const endDate = new Date(fim);

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    const diffTime = endDate.getTime() - startDate.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return Math.max(0, diffDays);
  }

  const getTodayDateString = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const statusFrom = (p: Pesquisa) => {
   return p.inativo ? "Inativo" : "Ativo";
  };

  function formatDateBR(dateString?: string) {
    if (!dateString) return "-";

    const d = new Date(dateString);
    if (isNaN(d.getTime())) return "-";

    return d.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }

  const mapPesquisa = (p: Pesquisa): Linha => ({
    id: p._id,
    titulo: p.titulo || "-",
    criadoPor:
      p.usuarioCriacao?.nome ||
      p.usuarioCriacao?.email ||
      p.usuarioCriacao?._id ||
      "-",
    criadoEm: p.dataCriacao || "-",
    dataInicio: p.inicio || "-",
    dataFim: p.termino || "-",
    status: statusFrom(p),
    pesquisaOriginal: p,
  });

  const fetchPesquisas = async () => {
    setUserLoading(true);
    try {
      const res = await getAllResearchs(jwt);
      if (res.success) {
        const raw = res.result;
             const arr = Array.isArray(raw)
          ? raw
          : Array.isArray(raw?.result)
          ? raw.result
          : [];
        const onlyVbg = arr.filter((p: any) => (p.origem || "").toUpperCase() === "VBG");

        const sortedResearchs = onlyVbg.sort((a:any, b:any) => {
          const dateA = new Date(a.dataCriacao || 0).getTime();
          const dateB = new Date(b.dataCriacao || 0).getTime();
          return dateB - dateA;
        });

        setAllResearchs(sortedResearchs);
      } else {
        toast.error("Erro ao buscar pesquisas.");
      }
    } catch {
      toast.error("Erro ao buscar pesquisas.");
    } finally {
      setUserLoading(false);
    }
  };


  useEffect(() => {
    fetchPesquisas();
  }, []);

  const rows = React.useMemo(() => {
    let list = [...allResearchs];

    const text = newResearch.trim().toLowerCase();
    if (text) {
      list = list.filter((p) => {
        return (
          (p.titulo?.toLowerCase() || "").includes(text) ||
          (p.usuarioCriacao?.nome?.toLowerCase() || "").includes(text) ||
          (p.usuarioCriacao?.email?.toLowerCase() || "").includes(text)
        );
      });
    }

    if (filtros.titulo.trim()) {
      const t = filtros.titulo.trim().toLowerCase();
      list = list.filter((p) => (p.titulo || "").toLowerCase().includes(t));
    }

     if (filtros.status) {
      list = list.filter((p) => {
        const statusAtual = statusFrom(p);

        if (filtros.status === "Ativo") {
          return statusAtual === "Ativo";
        } else if (filtros.status === "Inativo") {
          return statusAtual === "Inativo"; 
        }

        return true; 
      });
    }


    if (filtros.criadoDe || filtros.criadoAte) {
      const de = filtros.criadoDe
        ? new Date(filtros.criadoDe + "T00:00:00")
        : undefined;
      const ate = filtros.criadoAte
        ? new Date(filtros.criadoAte + "T23:59:59")
        : undefined;

      list = list.filter((p) => {
        if (!p.dataCriacao) return false;

        const d = new Date(p.dataCriacao);
        if (isNaN(d.getTime())) return false;

        if (de && d < de) return false;
        if (ate && d > ate) return false;
        return true;
      });
    }

    return list.map(mapPesquisa);
  }, [allResearchs, newResearch, filtros]);

  const todayMinDate = getTodayDateString();

  const columns: TableColumn<Linha>[] = React.useMemo(
    () => [
      {
        name: "Título",
        selector: (row) => row.titulo,
        sortable: true,
        grow: 2,
        wrap: true,
      },
      {
        name: "Criado por",
        selector: (row) => row.criadoPor,
        sortable: true,
        grow: 2,
        wrap: true,
        width: "200px",
      },
      {
        name: "Criado em",
        selector: (row) => formatDateBR(row.criadoEm),
        sortable: true,
        width: "110px",
        center: true,
        omit: hideColumnCompany,
      },
      {
        name: "Data de início",
        selector: (row) => formatDateBR(row.dataInicio),
        sortable: true,
        width: "110px",
        center: true,
        omit: hideColumnType,
      },
      {
        name: "Data de fim",
        selector: (row) => formatDateBR(row.dataFim),
        sortable: true,
        width: "110px",
        center: true,
        wrap: true,
      },
      {
        name: "Status",
        selector: (row) => row.status,
        sortable: true,
        width: "120px",
        wrap: true,
      },
      {
        name: "",
        cell: (row) => <ActionButtons {...row} />,
        width: "70px",
        center: true,
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
    ],
    [hideColumnCompany, hideColumnType]
  );

  const editUser = async (row: Linha) => {
    setShowOptions("edit");
    setSelectRow(row.pesquisaOriginal);
    setStateModal(true);
  };

  const ActionButtons = (row: any) => {
    return (
      <>
        <div onClick={() => editUser(row)}>
          <img
            src="/icones/pencil.svg"
            alt="editar"
            style={{ cursor: "pointer" }}
          />
        </div>
        &nbsp;&nbsp;&nbsp;&nbsp;
        {perfil.toUpperCase().indexOf("ADMINISTRADOR") >= 0 &&
          perfil.toUpperCase().indexOf("GS1") >= 0 && (
            <div onClick={() => openDelete(row.id)}>
              <img
                src="/icones/trash.svg"
                alt="trash"
                style={{ cursor: "pointer" }}
              />
            </div>
          )}
      </>
    );
  };

 const openDelete = (id: string) => {
    setIpsOpenModalDelete(true);
    setSelectRow(id); 
  };

const confirmDelete = async () => {
  const toastId = toast.loading("Deletando pesquisa...");
  try {
    const confirmDelete = await deleteResearch(jwt, selectRow);

    if (confirmDelete.success) {
      setAllResearchs((prev) => prev.filter((p) => p._id !== selectRow));

      toast.update(toastId, {
        render: "Registro excluído com sucesso.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
    } else {
      toast.update(toastId, {
        render: "Erro ao excluir registro.",
        type: "error",
        isLoading: false,
        autoClose: 4000,
        closeOnClick: true,
      });
    }
  } catch (error) {
    console.error(error);
    toast.update(toastId, {
      render: "Erro ao excluir registro.",
      type: "error",
      isLoading: false,
      autoClose: 4000,
      closeOnClick: true,
    });
  } finally {
    setIpsOpenModalDelete(false);
  }
  };

  const cancelDelete = () => {
    setIpsOpenModalDelete(false);
  };


  const handleClearFileAndCads = () => {
    setFile(null);
    setV("");
    setCadPreview([]);
    setCadCount(0);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setOpenEmbedCode(false);
  };

  const handleEditSuccess = async () => {
    await fetchPesquisas(); 
  };


  async function handleGetFile(file: File) {
    try {
      const ext = String(file.name).split(".").pop()?.toLowerCase();

      if (!ext || !["txt", "csv", "xlsx"].includes(ext)) {
        toast.error("Tipo de arquivo inválido. Envie apenas .xlsx, .txt ou .csv");
        return;
      }

      let raw = "";

      if (ext === "txt" || ext === "csv") {
        raw = await file.text();
      }

      if (ext === "xlsx") {
        const reader = new FileReader();

        const buffer: ArrayBuffer = await new Promise((resolve, reject) => {
          reader.onload = (e) => {
            if (!e.target?.result) {
              reject(new Error("Falha ao ler arquivo."));
            } else {
              resolve(e.target.result as ArrayBuffer);
            }
          };
          reader.onerror = reject;
          reader.readAsArrayBuffer(file);
        });

        const workbook = xlsx.read(buffer, { type: "buffer" });
        const workSheetName = workbook.SheetNames[0];
        const workSheet = workbook.Sheets[workSheetName];

        const lines: string[] = xlsx
          .utils.sheet_to_csv(workSheet)
          .split("\n")
          .filter((element: string | any[] | null) => {
            if (element != null && element.length > 0) return true;
          });

        raw = lines.join("\n");
      }

      const { ok, value, count, error } = normalizeCadList(raw);

      if (!ok || !value) {
        toast.error(error || "Arquivo de CADs inválido.");
        setV("");
        setCadPreview([]);
        setCadCount(0);
        setFile(null);
        return;
      }

      setV(value);
      setCadPreview(value.split(","));
      setCadCount(count);
      setFile(file);
      toast.success(`Arquivo carregado com ${count} CAD(s).`);
    } catch (error) {
      console.log(error);
      toast.error("Erro ao ler arquivo de CADs.");
    }
  }

  function validateResearchForm() {
    if (!titulo.trim()) return false;
    if (!embedCode.trim()) return false;
    if (!publico.trim()) return false;
    if (!selectProfile.trim()) return false;
    if (!researchPeriod.start || !researchPeriod.end) return false;

    if (publico === "Enviar planilha") {
      if (!v.trim()) return false;
    }

    if (publico === "Digitar CADs") {
      if (!textareaGTINs.trim()) return false;
    }

    return true;
  }

  const resetForm = () => {
    setTitulo("");
    setPublico("Enviar planilha");
    setEmbedCode("");
    setTextareaGTIns("");
    setFile(null);
    setResearchPeriod({ start: "", end: "" });
    setStatus(true);
    setV("");
    setCadPreview([]);
    setCadCount(0);
  };

  const newCreateResearch = async () => {
    if (!validateResearchForm()) {
      toast.error("Por favor, preencha todos os campos obrigatórios.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("titulo", titulo);
      formData.append("publico", publico);
      formData.append("embedCode", embedCode);
      formData.append("inicio", researchPeriod.start);
      formData.append("termino", researchPeriod.end);
      formData.append("status", status ? "true" : "false");

      if (publico === "Enviar planilha") {
        if (!v.trim()) {
          toast.error("Você precisa carregar um arquivo válido de CADs.");
          return;
        }
        formData.append("cadsSelecionados", v);
      } else if (publico === "Digitar CADs" && textareaGTINs) {
        const { ok, value, error } = normalizeCadList(textareaGTINs);
        if (!ok || !value) {
          toast.error(error || "Lista de CADs digitada é inválida.");
          return;
        }
        formData.append("cadsSelecionados", value);
      }

      const res = await createResearch(jwt, formData);

      if (res.success) {
        toast.success("Pesquisa criada com sucesso!");
        await fetchPesquisas();
        resetForm();
        setShowOptions("table");
        setShowTable(true);
      } else {
        toast.error(res.message || "Erro ao salvar pesquisa.");
      }
    } catch (err) {
      toast.error("Erro inesperado ao salvar pesquisa.");
      console.error(err);
    }
  };

  function normalizeCadList(input: string) {
    const replaced = input.replace(/[\r\n;]+/g, ",");

    const parts = replaced
      .split(",")
      .map((p) => p.trim())
      .filter((p) => p.length > 0);

    if (parts.length === 0) {
      return {
        ok: false,
        error: "Nenhum CAD encontrado. Verifique o arquivo.",
      };
    }

    const invalid = parts.filter((p) => !/^[A-Za-z0-9]+$/.test(p));
    if (invalid.length > 0) {
      return {
        ok: false,
        error: `Foram encontrados CADs inválidos: ${invalid
          .slice(0, 5)
          .join(", ")}`,
      };
    }

    return {
      ok: true,
      value: parts.join(","),
      count: parts.length,
    };
  }

  return (
    <TemplateBackend>
      <div style={{ height: "1000px", marginBottom: "180px" }}>
        <div className="containerResearch">
          <h3 style={{ marginTop: 0 }}>
            {showOptions === "table"
              ? "Lista de pesquisas"
              : showOptions === "form"
              ? "Criar nova pesquisa"
              : "Editar pesquisa"}
          </h3>
        </div>

        {showOptions === "table" ? (
          <div className="containerHeader">
            <div className="containerHeaderContent">
              <div className="containerInputSearch">
                <label className="containerLabelSearch">
                  <BsSearch />
                  <input
                    style={{ height: "39px", marginLeft: "10px" }}
                    type="text"
                    placeholder="Pesquisar..."
                    value={newResearch}
                    onChange={(e) => {
                      setNewResearch(e.target.value);
                    }}
                    className="inputResearch"
                  />
                </label>
                <div
                  className="svgFilter"
                  onClick={() => setShowFilterModal(true)}
                >
                  <BsFilter />
                </div>
              </div>

              <div className="containerButtonNewResearch">
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => {
                    setShowOptions("form");
                    setShowTable(false);
                  }}
                >
                  Nova pesquisa
                </button>
              </div>
            </div>

            <div className="containerDataTable">
              <div className="contentDataTable">
                <DataTable
                  columns={columns}
                  data={rows}
                  pagination
                  paginationComponent={BootyPagination}
                  responsive
                  highlightOnHover
                  noDataComponent="Sem registros para exibir"
                  progressPending={userLoading}
                  progressComponent={<Loading />}
                  customStyles={customStyles}
                />
              </div>
            </div>
          </div>
        ) : showOptions === "form" ? (
          <div className="containerNewResearch">
            <div className="containerContentNewResearch">
              <div className="form-group">
                <span className="form-label">Título</span>
                <input
                  required
                  onChange={(e) => {
                    setTitulo(e.target.value);
                  }}
                  value={titulo}
                  type="text"
                  className="form-control"
                  placeholder="Digite aqui"
                />
              </div>

              <div className="form-group">
                <span className="form-label">Público alvo da pesquisa</span>
                <div className="form-group-radio">
                  <div>
                    <label>
                      <input
                        type="radio"
                        required
                        name="publico"
                        value="Enviar planilha"
                        checked={publico === "Enviar planilha"}
                        onChange={(e) => setPublico(e.target.value)}
                      />{" "}
                      Enviar planilha
                    </label>
                  </div>

                  <div>
                    <label>
                      <input
                        type="radio"
                        required
                        style={{ marginLeft: "15px" }}
                        name="publico"
                        value="Digitar CADs"
                        checked={publico === "Digitar CADs"}
                        onChange={(e) => setPublico(e.target.value)}
                      />{" "}
                      Digitar CADs
                    </label>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <span className="form-label">
                  {publico === "Enviar planilha"
                    ? "Enviar uma lista com números de cad, organizados em uma única coluna"
                    : "Digite CADs separados por vírgula"}
                </span>

                {publico === "Enviar planilha" ? (
                  <>
                    {!file && (
                      <label
                        htmlFor="file-upload"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                          width: "100%",
                          height: "150px",
                          border: "2px dashed #1f3567",
                          borderRadius: "3px",
                          cursor: "pointer",
                          background: "#e5effc",
                          color: "#555",
                          fontSize: "14px",
                          fontWeight: 500,
                        }}
                      >
                        <span>Clique ou arraste um arquivo aqui</span>
                        <small style={{ color: "#888", marginTop: "5px" }}>
                          Tipos aceitos: .xlsx, .txt, .csv
                        </small>
                      </label>
                    )}

                    <input
                      required
                      id="file-upload"
                      accept=".xlsx, .txt, .csv"
                      type="file"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        if (
                          e &&
                          e.target &&
                          e.target.files &&
                          e.target.files.length > 0
                        ) {
                          handleGetFile(e.target.files[0]);
                          e.target.value = "";
                        }
                      }}
                    />

                    {file && (
                      <div
                        style={{
                          marginTop: "10px",
                          padding: "8px 10px",
                          borderRadius: "4px",
                          background: "#eef4ff",
                          fontSize: "13px",
                          color: "#333",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <div>
                          <strong>Arquivo selecionado:</strong>{" "}
                          <span>{file.name}</span>
                          {cadCount > 0 && (
                            <span
                              style={{ marginLeft: "8px", color: "#555" }}
                            >
                              — {cadCount} CAD(s) encontrados
                            </span>
                          )}
                        </div>

                        <button
                          type="button"
                          className="btn btn-link btn-sm"
                          style={{
                            color: "#c0392b",
                            textDecoration: "none",
                          }}
                          onClick={handleClearFileAndCads}
                        >
                          Remover arquivo
                        </button>
                      </div>
                    )}

                    {cadCount > 0 && (
                      <div
                        style={{
                          marginTop: "10px",
                          padding: "8px 10px",
                          borderRadius: "4px",
                          background: "#f5f5f5",
                          fontSize: "13px",
                          color: "#333",
                        }}
                      >
                        <strong>{cadCount} CAD(s) carregados.</strong>
                        <div style={{ marginTop: "4px" }}>
                          Pré-visualização:&nbsp;
                          <code style={{ color: "#354674" }}>
                            {cadPreview.slice(0, 20).join(", ")}
                            {cadPreview.length > 20 && " ..."}
                          </code>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <textarea
                    required
                    onChange={(e) => {
                      setTextareaGTIns(e.target.value);
                    }}
                    value={textareaGTINs}
                    rows={4}
                    className="form-control"
                    placeholder="Digite aqui"
                  />
                )}
              </div>

              <div className="form-group">
                <span className="form-label">Código de pesquisa</span>
                <textarea
                  required
                  onChange={(e) => setEmbedCode(e.target.value)}
                  value={embedCode}
                  rows={4}
                  className="form-control"
                  placeholder="Embed Code"
                />
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <button
                  className="btn btn-primary btn-sm"
                  style={{ marginBottom: "20px" }}
                  onClick={() => {
                    if (embedCode.trim() === "") {
                      toast.error(
                        "Por favor, insira o embed code antes de visualizar."
                      );
                      return;
                    }
                    setOpenEmbedCode(true);
                  }}
                >
                  Mostrar embed code
                </button>
              </div>

              <div className="form-group">
                <span className="form-label">
                  Periodo de divulgação da pesquisa
                </span>
                <div className="form-group-date">
                  <div>
                    <input
                      type="date"
                      required
                      value={researchPeriod.start}
                      min={todayMinDate}
                      className="form-control"
                      onChange={(e) => {
                        setResearchPeriod({
                          ...researchPeriod,
                          start: e.target.value,
                        });
                      }}
                      placeholder="inicio (dd/MM/yyyy)"
                    />
                  </div>
                  <div>
                    <input
                      type="date"
                      min={todayMinDate}
                      required
                      value={researchPeriod.end}
                      style={{ marginLeft: "15px" }}
                      className="form-control"
                      placeholder="Fim (dd/MM/yyyy)"
                      onChange={(e) => {
                        const newEnd = e.target.value;
                        const startDate = new Date(researchPeriod.start);
                        const endDate = new Date(newEnd);

                        if (endDate <= startDate) {
                          toast.error(
                            "A data fim não pode ser igual ou menor que a data de início."
                          );
                          setResearchPeriod({
                            ...researchPeriod,
                            end: "",
                          });
                          return;
                        }

                        setResearchPeriod({
                          ...researchPeriod,
                          end: newEnd,
                        });
                      }}
                    />
                  </div>
                  <div
                    style={{
                      marginLeft: "30px",
                      color: "#414345",
                      fontSize: "15px",
                      marginTop: "7px",
                    }}
                  >
                    {calcularDias(researchPeriod.start, researchPeriod.end)} dias
                  </div>
                </div>
              </div>

              <div className="form-group">
                <span className="form-label">Status</span>
                <label style={{ marginLeft: "15px", cursor: "pointer" }}>
                  <input
                    required
                    type="checkbox"
                    checked={status}
                    onChange={() => setStatus(!status)}
                    style={{ display: "none" }}
                  />
                  <span
                    style={{
                      display: "inline-block",
                      width: "40px",
                      height: "20px",
                      background: status ? "#4caf50" : "#ccc",
                      borderRadius: "20px",
                      position: "relative",
                      transition: "0.3s",
                    }}
                  >
                    <span
                      style={{
                        content: "",
                        position: "absolute",
                        top: "2px",
                        left: status ? "22px" : "2px",
                        width: "16px",
                        height: "16px",
                        background: "#fff",
                        borderRadius: "50%",
                        transition: "0.3s",
                      }}
                    />
                  </span>
                </label>
              </div>
            </div>

            <div className="containerButtonsNewResearch">
              <div>
                <button
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => {
                    setShowOptions("table");
                    setShowTable(true);
                  }}
                >
                  Cancelar
                </button>
              </div>
              <div>
                <button
                  className="btn btn-primary btn-sm"
                  style={{ marginLeft: "15px" }}
                  onClick={() => {
                    setShowTable(true);
                    newCreateResearch();
                  }}
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <ModalEdit
              selectRow={selectRow}
              onSuccess={handleEditSuccess}   
              closeModal={() => setShowOptions("table")}
            />
          </div>
        )}
      </div>

      <div>
        <ModalFilter
          stateModal={showFilterModal}
          close={() => setShowFilterModal(false)}
          filtros={filtros}
          onApply={(f) => {
            setFiltros(f);
            setShowFilterModal(false);
          }}
        />
      </div>
      <div>
        <PreviewEmbedModal
          stateModal={openEmbedCode}
          close={closeModal}
          embedCode={embedCode}
        />
      </div>

      <Modal
              isOpen={ipsOpenModalDelete}
              contentLabel="Selected Option"
              style={{
                overlay: {
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: '#262626CC',
                  zIndex: 1000,
                },
                content: {
                  maxWidth: '485px',
                  height: '270px',
                  marginTop: '5%',
                  marginBottom: 0,
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  zIndex: 1000,
                  border: '1px solid #ccc',
                  background: '#fff',
                  overflow: 'auto',
                  WebkitOverflowScrolling: 'touch',
                  borderRadius: '20px',
                  outline: 'none',
                  padding: '10px',
                },
              }}
            >
              <div style={{ padding: '0.5rem' }}>
                <span
                  onClick={() => setIpsOpenModalDelete(false)}
                  style={{ position: 'absolute', right: '7px', top: '7px', cursor: 'pointer' }}
                  aria-label="Fechar modal"
                  title="Fechar"
                >
                  <IoMdClose />
                </span>
      
                <div style={{ display: 'flex', flexDirection: 'column', rowGap: '2rem' }}>
                  <div style={{ color: 'rgb(105, 109, 115)', marginBottom: '-15px' }}>
                    <div className="section">
                      <div
                        className="custom-col12 col-md-12"
                        style={{ display: 'flex', fontSize: '17px' }}
                      >
                        <div
                          className="w-1/2 md:w-full table-responsive"
                          style={{ textAlign: 'left', lineHeight: '1.3' }}
                        >
                          <div
                            className="custom-fontSize"
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '180px',
                              textAlign: 'justify',
                            }}
                          >
                            <div
                              style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                marginBottom: '20px',
                              }}
                            >
                              <span style={{ fontWeight: 'bold', color: '#002C6C' }}>
                                Atenção!
                              </span>
                            </div>
                            <div className="flex" style={{ display: 'grid', gap: 8 }}>
                              <div>
                                Você tem certeza que deseja excluir ? Essa ação não pode ser desfeita.
                              </div>
                            </div>
                          </div>
      
                          <div
                            className="custom-display-buttons"
                            style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}
                          >
                            <div
                              className="sm: mt-0"
                              style={{ textAlign: 'right', marginTop: '-15px' }}
                            >
                              <button
                                style={{ maxWidth: '170px', marginRight: '10px' }}
                                className="btn btn-outline-primary custom-fontSize"
                                onClick={cancelDelete}
                              >
                                Cancelar
                              </button>
                            </div>
      
                            <div
                              className="sm: mt-0"
                              style={{ textAlign: 'right', marginTop: '-15px' }}
                            >
                              <button
                                style={{ maxWidth: '170px' }}
                                className="btn btn-primary custom-fontSize"
                                onClick={confirmDelete}
                              >
                                Excluir
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>

    </TemplateBackend>
  );
};

export default Research;
